import React from 'react';
import {
  ReactiveBase,
  DataSearch,
  ReactiveList,
  StateProvider,
  SingleList,
} from '@appbaseio/reactivesearch';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { FilterSelect } from '../ExhibitorsCatalog/FilterSelect';
import reactivesearchTheme from '../../reactivesearchTheme';

import './site-search.css';

function SiteSearch({ url, credentials, app }) {
  return (
    <ReactiveBase
      url={url}
      credentials={credentials}
      app={app}
      enableAppbase
      theme={reactivesearchTheme}
    >
      <div className="filters-block">
        <form className="filter-box site-search__form">
          <fieldset>
            <div className="filter-holder">
              <div className="search-filter">
                <DataSearch
                  innerClass={{
                    input: 'form-control',
                  }}
                  componentId="q"
                  dataField={['title', 'content']}
                  iconPosition="right"
                  filterLabel="Search term"
                  placeholder="Search"
                  react={{ and: ['type'] }}
                  URLParams
                  highlight
                  customHighlight={() => ({
                    pre_tags: ['<mark>'],
                    post_tags: ['</mark>'],
                    number_of_fragments: 3,
                    fields: {
                      title: { number_of_fragments: 0 },
                      content: {},
                    },
                  })}
                  // searchOperators
                  fuzziness="AUTO"
                />
              </div>
              <div className="select-filter">
                <SingleList
                  componentId="type"
                  dataField="type.keyword"
                  filterLabel="Type"
                  react={{ and: ['q'] }}
                  URLParams
                  showSearch={false}
                  render={({
                    data,
                    value,
                    handleChange,
                  }) => (
                    <FilterSelect
                      data={data}
                      value={value}
                      emptyValue="All types"
                      onChange={(e) => handleChange(e.target.value)}
                    />
                  )}
                />
              </div>
            </div>
          </fieldset>
        </form>
        <div className="load-more-box">
          <StateProvider
            strict={false}
            render={({ searchState }) => {
              if (!searchState.q?.value) {
                return (
                  <h3 className="search-results-stats__search-term search-results-stats__search-term--empty">
                    Please enter the search term.
                  </h3>
                );
              }

              const pageSize = 12;
              const hits = _.get(searchState, 'page.hits.total', 0);
              const numberOfPages = hits > 0 ? Math.ceil(hits / pageSize) : 0;

              return (
                <ReactiveList
                  componentId="page"
                  innerClass={{ pagination: 'pagination reactive-pagination' }}
                  dataField="id"
                  pagination
                  size={pageSize}
                  showEndPage={numberOfPages > 8}
                  pages={numberOfPages > 8 ? 8 : numberOfPages}
                  showResultStats
                  URLParams
                  react={{ and: ['q', 'type'] }}
                  renderNoResults={() => (
                    <h3 className="search-results-stats__search-term search-results-stats__search-term--empty">
                      No Results found.
                    </h3>
                  )}
                  renderResultStats={({ numberOfResults }) => (
                    <h3 className="search-results-stats__search-term">
                      {numberOfResults === 1
                        ? (`${numberOfResults} result for ${searchState.q?.value}`)
                        : (`${numberOfResults} results for ${searchState.q?.value}`)}
                    </h3>
                  )}
                  render={({ data }) => (
                    <div className="ajax-load-content">
                      {data.map((item) => (
                        /* eslint-disable-next-line no-underscore-dangle */
                        <div key={item._id} className="result-line">
                          <a href={item.url}>
                            <div className="result-meta">
                              <ul className="breadcrumb">
                                {item.breadcrumbs?.map((el) => <li key={el.label} className="breadcrumb-item">{el.label}</li>)}
                              </ul>
                              <div className="result-line__uri">{`/${item.uri}`}</div>
                            </div>

                            {/* To allow highlights. The content is already sanitized. */}
                            {/* eslint-disable-next-line react/no-danger */}
                            <h4 className="result-line__title" dangerouslySetInnerHTML={{ __html: item.title }} />

                            {/* eslint-disable-next-line react/no-danger */}
                            <p className="result-line__description" dangerouslySetInnerHTML={{ __html: item.content.slice(0, 250) + (item.content.length > 250 ? '...' : '') }} />
                          </a>
                        </div>
                      ))}
                    </div>
                  )}
                />
              );
            }}
          />
        </div>
      </div>
    </ReactiveBase>
  );
}

SiteSearch.propTypes = {
  url: PropTypes.string.isRequired,
  credentials: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
};

export { SiteSearch };
